'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = require('vuex');

exports.default = {
  name: "Header",

  computed: Object.assign({}, (0, _vuex.mapState)({
    step: function step(state) {
      return state.prescription.step;
    },
    cms: function cms(state) {
      return state.prescription.cms.global;
    }
  })),

  methods: Object.assign({}, (0, _vuex.mapMutations)(['setStep']), {
    isStep: function isStep(step) {
      var stepNumber = step;
      return stepNumber === this.step;
    },
    isComplete: function isComplete(step) {
      var stepNumber = step;
      return stepNumber < this.step;
    },
    previousStep: function previousStep() {
      var activeStep = this.step;
      activeStep--;
      this.setStep(activeStep);
    }
  })
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//